export default {
  apiKey: 'rovisport2xRovisport47oCAz',
  // googleAnalyticsKey: '',
  debug: {
    translation: true,
  },
};
